// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "label[data-v-53fefc70]{padding-top:5px}#house-settings-save-changes-button[data-v-53fefc70]{margin-top:15px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
